import script from "./Individual.vue?vue&type=script&setup=true&lang=ts"
export * from "./Individual.vue?vue&type=script&setup=true&lang=ts"

import "./Individual.vue?vue&type=style&index=0&id=5a26b645&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a26b645"]])

export default __exports__